import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import maskot from "../../assets/kominfo - maskot-01.png";
import homePage1 from "../../assets/webinar-privyid.png";
// import homePage1 from "../../assets/homepage-hero-1.png";
import homePage2 from "../../assets/homepage-hero-2.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export default ({ listBanner, baseURL }) => {
  // console.log(props);
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://unpkg.com/flickity@2/dist/flickity.pkgd.js";
  //   document.getElementsByClassName("main-carousel")[0].appendChild(script);
  // }, []);

  return (
    <section className="psre-satu">
      <div className="row mt-4">
        <div className="col-lg-3 col-md-3 col-sm-12 col-12">
          <div
            className="card card-primary col-psre-satu"
            style={{ zIndex: 1 }}
          >
            <div className="card-body">
              <p style={{ fontSize: "22px", marginBottom: "20px" }}>
                Layanan Digital Terpercaya
              </p>
              <table className="table table-borderless w-100">
                <tbody>
                  <tr>
                    <td>
                      <img
                        src={maskot}
                        alt="burung garuda pancasila"
                        style={{ width: "50px", height: "auto" }}
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "12px", lineHeight: "18px" }}
                      >
                        Penyelenggara Sertifikasi Elektronik (PSrE)
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <form className="mb-0" action="">
                <select className="select-primary form-control" id="">
                  <option hidden selected="" value="">
                    Pemanfaatan Sertifikat Elektronik
                  </option>
                  <option value="">Tanda Tangan Elektronik</option>
                  <option value="">Identitas Digital</option>
                </select>
                <Link
                  to="/apaitu"
                  className="btn btn-blue w-100 mb-3"
                  style={{ marginTop: "15px", padding: "11px 25px !important" }}
                >
                  Pelajari Lebih Lanjut
                </Link>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-9 col-sm-12 col-12">
          <Carousel
            swipeable={true}
            draggable={true}
            showDots={true}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2000}
            keyBoardControl={true}
            customTransition="all .5"
            transitionDuration={2000}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
            // deviceType={this.props.deviceType}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
          >
            {listBanner.length
              ? listBanner.map((e) => {
                  return (
                    <div>
                      <div className="position-relative w-100">
                        <img
                          src={baseURL + e.image}
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "5px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div className="caption-hero d-none d-lg-block">
                        <div
                          className="d-flex"
                          style={{
                            justifyContent: "flex-end",
                            marginRight: 60,
                          }}
                        >
                          {
                            <p
                              className="mr-5"
                              style={{
                                fontSize: "13px",
                                color: "white",
                                marginBottom: "0px;",
                              }}
                            >
                              {e.title || ""}
                            </p>
                          }
                          <a
                            href={e.link}
                            className="btn btn-blue"
                            target="_blank"
                            style={{
                              padding: "8px 25px !important",
                              fontSize: "13px",
                            }}
                          >
                            {e.buttonCaption || "Kunjungi"}
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })
              : null}
            {/* <div>
              <div className="position-relative w-100">
                <img
                  src={homePage1}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "5px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="caption-hero d-none d-lg-block">
                <div
                  className="d-flex"
                  style={{ justifyContent: "flex-end", marginRight: 60 }}
                >
                  <a
                    href="https://komin.fo/WebinarTTE1"
                    className="btn btn-blue"
                    target='_blank'
                    style={{ padding: "8px 25px !important", fontSize: "13px" }}
                  >
                    Daftar Disini
                  </a>
                </div>
              </div>
            </div> */}
            {/* <div>
              <div className="position-relative w-100">
                <img
                  src={homePage2}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "5px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="caption-hero d-none d-lg-block">
                <div
                  className="d-flex"
                  style={{ justifyContent: "flex-end", marginRight: 60 }}
                >
                  <p
                    className="mr-5"
                    style={{
                      fontSize: "13px",
                      color: "white",
                      marginBottom: "0px;",
                    }}
                  >
                    Promosi dan Bimbingan Teknis <br />
                    Pemanfaatan Tanda Tangan Elektronik
                  </p>
                  <a
                    href=""
                    className="btn btn-blue"
                    style={{ padding: "8px 25px !important", fontSize: "13px" }}
                  >
                    Kunjungi
                  </a>
                </div>
              </div>
            </div> */}
          </Carousel>
          {/* <div className="main-carousel" data-flickity="" >
            <div className="carousel-cell">
              <div className="position-relative w-100">
                <img src={homePage1} style={{width: '100%', height: '467px',borderRadius: '5px', objectFit: 'cover'}} />
              </div>
              <div className="caption-hero d-none d-lg-block">
                <div className="d-flex" style={{justifyContent: 'flex-end'}}>
                  <p className="mr-5" style={{fontSize: '13px', color: 'white', marginBottom: '0px;'}}>Pelajari Informasi Lengkap Tentang <br/> PSrE dan Manfaatnya</p>
                  <a href="" className="btn btn-blue" style={{padding: '8px 25px !important', fontSize: '13px'}}>Kunjungi</a>
                </div>
              </div>
            </div>
            <div className="carousel-cell">
              <div className="position-relative w-100">
                <img src={homePage2} style={{width: '100%', height: '467px',borderRadius: '5px', objectFit: 'cover'}} />
              </div>
              <div className="caption-hero d-none d-lg-block">
                <div className="d-flex" style={{justifyContent: 'flex-end'}}>
                  <p className="mr-5" style={{fontSize: '13px', color: 'white', marginBottom: '0px;'}}>Promosi dan Bimbingan Teknis <br/>Pemanfaatan Tanda Tangan Elektronik</p>
                  <a href="" className="btn btn-blue" style={{padding: '8px 25px !important', fontSize: '13px'}}>Kunjungi</a>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};
